import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

export const minutesToHourMinuteSecond = (minute: Numberlish) => {
  const totalMinutes = Number(minute);

  if (isNaN(totalMinutes))
    return { hours: 0, minutes: 0, seconds: 0, formatted: '0h 0m 0s' };

  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.floor(totalMinutes % 60);
  const seconds = Math.floor((totalMinutes % 1) * 60);

  return {
    hours,
    minutes,
    seconds,
  };
};

const formatTimeUnit = (
  value: number,
  unit: string,
  padStart: number,
): string => {
  return `${value.toString().padStart(padStart, '0')}${unit}`;
};

const formatTime = (
  minute: Numberlish,
  units: ('h' | 'm' | 's')[],
  options: { padStart?: number; upperCase?: boolean } = {},
): string => {
  const { padStart = 0, upperCase = false } = options;
  const { hours, minutes, seconds } = minutesToHourMinuteSecond(minute);

  const parts: string[] = [];

  if (units.includes('h')) {
    parts.push(formatTimeUnit(hours, 'h', padStart));
  }
  if (units.includes('m')) {
    parts.push(formatTimeUnit(minutes, 'm', padStart));
  }
  if (units.includes('s')) {
    parts.push(formatTimeUnit(seconds, 's', padStart));
  }

  const result = parts.join(' ');
  return upperCase ? result.toUpperCase() : result;
};

export const minutesToHMS = (
  minute: Numberlish,
  options: { padStart?: number; upperCase?: boolean } = {},
) => formatTime(minute, ['h', 'm', 's'], options);

export const minutesToHM = (
  minute: Numberlish,
  options: { padStart?: number; upperCase?: boolean } = {},
) => formatTime(minute, ['h', 'm'], options);

export const minutesToH = (
  minute: Numberlish,
  options: { padStart?: number; upperCase?: boolean } = {},
) => formatTime(minute, ['h'], options);

export const isMondayToThursday = (date: Dayjs) => {
  return date.day() >= 1 && date.day() <= 4;
};

export const getMonthWeekInfo = (date: Dayjs) => {
  const thisWeekMonday =
    date.day() === 0
      ? date.startOf('week').subtract(6, 'day')
      : date.startOf('week').add(1, 'day');
  const thisWeekThursday = thisWeekMonday.add(3, 'day');
  const thisWeekSunday = thisWeekMonday.add(6, 'day');

  const thisYear = thisWeekThursday.year();
  const thisMonth = thisWeekThursday.month();
  const thisMonthFirstDay = dayjs().year(thisYear).month(thisMonth).date(1);

  const thisMonthFirstMonday = isMondayToThursday(thisMonthFirstDay)
    ? thisMonthFirstDay.startOf('week').add(1, 'day')
    : thisMonthFirstDay.add(1, 'week').startOf('week').add(1, 'day');
  const weekDiff = date.diff(thisMonthFirstMonday, 'week');

  return {
    year: thisYear,
    month: thisMonth + 1,
    thisMonthWeekNum: weekDiff + 1,

    thisWeekMonday,
    thisWeekSunday,
  };
};
